module.exports = __webpack_public_path__ + "assets/twitch-icon-white.png";